import React, { useState, useEffect } from "react";

const RandomScorePopup = ({ onStop }) => {
  const [randomScore, setRandomScore] = useState(1);
  const [intervalId, setIntervalId] = useState(null);
  const [stop, setStop] = useState(false);
  const [randomSequence, setRandomSequence] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  // useEffect(() => {
  //   const generateRandomSequence = () => {
  //     const numbers = [1, 2, 3, 4, 5, 6];
  //     for (let i = numbers.length - 1; i > 0; i--) {
  //       const j = Math.floor(Math.random() * (i + 1));
  //       [numbers[i], numbers[j]] = [numbers[j], numbers[i]];
  //     }
  //     return numbers;
  //   };

  //   const sequence = generateRandomSequence();
  //   console.log(sequence);
  //   setRandomSequence(sequence);

  //   const id = setInterval(() => {
  //     setCurrentIndex((prevIndex) => {
  //       const newIndex = (prevIndex + 1) % sequence.length;
  //       setRandomScore(sequence[newIndex]);
  //       return newIndex;
  //     });
  //   }, 70);

  //   setIntervalId(id);

  //   return () => clearInterval(id);
  // }, []);

  // const handleStopClick = () => {
  //   clearInterval(intervalId);
  //   setStop(true);
  // };

  const handleNextClick = () => {
    onStop(randomScore);
  };

  return (
    <div className="flex flex-col items-center justify-center h-max">
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <div className="mb-4 text-2xl font-bold text-green-500">Correct!</div>
        {/* <div className="mb-4 text-2xl">Let’s Make Some Runs</div>
        <h1 className="text-6xl font-bold text-blue-500 mb-8">{randomScore}</h1> */}

        <button
            onClick={handleNextClick}
            className="border-b-4 border-green-700 bg-green-500 w-full text-white py-2 px-4 rounded-lg transition-colors"
          >
            NEXT
          </button>
      </div>
    </div>
  );
};

export default RandomScorePopup;
